import { render, staticRenderFns } from "./ManuallyDescribeServiceStep.vue?vue&type=template&id=13a3549a"
import script from "./ManuallyDescribeServiceStep.vue?vue&type=script&lang=js"
export * from "./ManuallyDescribeServiceStep.vue?vue&type=script&lang=js"
import style0 from "./ManuallyDescribeServiceStep.vue?vue&type=style&index=0&id=13a3549a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports